import { FC } from 'react';
import { Service } from './Service/Service';
import { store } from '@/config/store';
import { useFetchBanners } from '@/hooks/api/banner/useFetchBanners';

type ServicePageProps = {
  id: string;
  categoryName?: string;
};

export const ServicePage: FC<ServicePageProps> = ({ id, categoryName }) => {
  const numericId = Number(id);
  const affiliate_id = store.state.customerInfo.m_affiliate_id;

  const { banners } = useFetchBanners({
    m_mt_service_category_id: numericId,
    m_affiliate_id: affiliate_id,
  });

  return (
    <Service
      id={numericId}
      categoryName={categoryName}
      banners={banners}
    />
  );
};
